import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ErrorState } from './ui/states.js';

/**
 * Catches a render crash so the user sees what went wrong and can try again, instead of a blank page
 * (BS-068). The error is logged, never swallowed. `resetKey` (e.g. the path) clears it on navigation.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: unknown }> {
  override state: { error: unknown } = { error: null };
  static getDerivedStateFromError(error: unknown) { return { error }; }
  override componentDidCatch(error: unknown, info: ErrorInfo) { console.error('Screen crashed', error, info.componentStack); }
  override componentDidUpdate(prev: { resetKey?: string }) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }
  override render() {
    if (this.state.error) {
      return (
        <div className="p-6">
          <ErrorState title="Something broke on this screen" error={this.state.error}
            onRetry={() => this.setState({ error: null })} />
        </div>
      );
    }
    return this.props.children;
  }
}
